import { ISolutionPage } from '..'
import React from 'react'

export function ResourcesTab(page: ISolutionPage): React.ReactElement {
  return <span>{`${page.solution?.name} resources`}</span>
}
